import axios from 'axios';

export const parametersApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/parameter`,
    headers: {
        'Content-Type': 'application/json'
    }
})